import React from 'react'

const BannerLanding = (props) => (
    <section id="banner" className="style2">
        <div className="inner">
            <header className="major">
                <h1>Architectural Descriptions of Farm Structures</h1>
            </header>
            <div className="content">
                <p>This is the landing page for architectural information -
                Check back soon!</p>
            </div>
        </div>
    </section>
)

export default BannerLanding



// WEBPACK FOOTER //
// ./src/components/BannerLanding.js